import { type ReactNode } from 'react'

export interface AnswerEditorBodyProps {
  children?: ReactNode
  /**
   * Test ID attribute for the wrapper.
   */
  testId?: string
}

/**
 * Wrapper for answer editors, ensuring there's a bit of extra vertical spacing
 * to account for any focus outlines.
 */
export function AnswerEditorBody({ children, testId }: AnswerEditorBodyProps) {
  return (
    <div className="py-md" data-test={testId}>
      {children}
    </div>
  )
}
